import React, { useRef, useState } from 'react'
import InputText from '../input-text/input-text'
import * as ZipCodeUtility from '@components/utilities/zipCode-utility'
import inputProptypes from '@components/input/input-proptype'
import * as BaseFunctions from '../base-functions'
import { useInitialValueToValidation } from '../custom-hooks'
import useEvents from '@components/utilities/event-hooks-utility'

const CEP_QUANTITY_WITH_HYPHEN = 9

const InputZipcode = ({ onChange, onBlur, errorMessage, value, onFieldValidation, name, required, ...rest }) => {
  const [currentErrorMessage, setCurrentErrorMessage] = useState(errorMessage)
  const [inputValue, setInputValue] = useState(value || '')
  const [currentName] = useState(BaseFunctions.getInputName(name))

  const thisInput = useRef(null)
  const defaultEvents = useEvents(thisInput)

  const defaultErrorMessage = errorMessage || 'O CEP precisa ter 8 dígitos.'

  const validateZipCode = async value => {
    if (!value?.length && !required) return setCurrentErrorMessage('')
    if (value?.length !== CEP_QUANTITY_WITH_HYPHEN) {
      setCurrentErrorMessage(defaultErrorMessage)
      await BaseFunctions.handlerOnFieldValidation(onFieldValidation, currentName, true)
      return
    }
    setCurrentErrorMessage('')
  }

  const handleOnChange = defaultEvents.useOnChange(async ({ value, id, name }) => {
    const { unmaskedZipCode, maskedZipCode } = ZipCodeUtility.maskZipcode(value)

    setInputValue(maskedZipCode)
    if (onChange) {
      await onChange({ value: unmaskedZipCode, maskedValue: maskedZipCode, id, name })
    }

    return maskedZipCode
  })

  const handleOnBlur = value => {
    setCurrentErrorMessage('')
    const { unmaskedZipCode, maskedZipCode } = ZipCodeUtility.maskZipcode(value)
    validateZipCode(maskedZipCode)

    if (onBlur) onBlur(unmaskedZipCode, maskedZipCode)
  }

  let inputProps = {
    type: 'tel',
    onChange: handleOnChange,
    onBlur: handleOnBlur,
    errorMessage,
    maxLength: CEP_QUANTITY_WITH_HYPHEN,
    errorMessage: currentErrorMessage,
    value: inputValue,
    name: currentName,
    onFieldValidation,
    inputRef: thisInput,
    onKeyUp: defaultEvents.onKeyUp,
    required,
    ...rest,
  }

  useInitialValueToValidation(value, () => {
    if (!value) return
    const { maskedZipCode } = ZipCodeUtility.maskZipcode(value)

    setInputValue(maskedZipCode)
    validateZipCode(maskedZipCode)
  })

  return <InputText {...inputProps} />
}

InputZipcode.propTypes = inputProptypes

export default InputZipcode
